export default __webpack_public_path__ + "static/media/LineGraph.6aa99cc4.svg";